import { atom as e } from "jotai";
import { FIRST_NAME_FIELD as F, LAST_NAME_FIELD as L, EMAIL_FIELD as c, COUNTRY_FIELD as m, PHONE_COUNTRY_FIELD as a, COUNTRY_CODE_FIELD as A, PHONE_NUMBER_FIELD as N, ADDRESS_FIELD as o, CITY_FIELD as _, REGION_FIELD as D, POSTAL_CODE_FIELD as s, REQUEST_FIELD as i, CONSENT_COMMUNICATE_BY_PHONE_FIELD as r } from "./index56.mjs";
import { atomWithDefault as C } from "jotai/utils";
const u = [o, _, s], f = [
  D,
  i,
  r
], O = {
  [F]: "",
  [L]: "",
  [c]: "",
  [m]: "",
  [a]: "",
  [A]: "",
  [N]: "",
  [o]: "",
  [_]: "",
  [D]: "",
  [s]: "",
  [i]: "",
  consent_communicate_by_phone: !0
}, T = e(O), E = C(
  (t) => t(T)
), p = e(
  (t) => t(E)
), M = e(
  null,
  (t, l, n) => {
    const I = t(E);
    l(E, {
      ...I,
      ...n
    });
  }
);
export {
  E as clientDetailsAtom,
  T as clientDetailsAtomDefault,
  u as fullAddressFields,
  O as initialState,
  f as optionalAddressFields,
  p as selectedClientDetailsAtom,
  M as setClientDetailsAtom
};
